export const ZapMock = () => {
  return (
    <svg
      width="125"
      height="100"
      viewBox="0 0 125 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M62.1378 61.1862C62.2784 61.3268 62.5063 61.3268 62.6469 61.1862L64.9379 58.8952C65.0785 58.7546 65.0785 58.5266 64.9379 58.3861C64.7973 58.2455 64.5694 58.2455 64.4288 58.3861L62.3923 60.4225L60.3559 58.3861C60.2153 58.2455 59.9873 58.2455 59.8467 58.3861C59.7062 58.5266 59.7062 58.7546 59.8467 58.8952L62.1378 61.1862ZM62.0323 24.6016V60.9316H62.7523V24.6016H62.0323Z"
        fill="#B5B2AA"
      />
      <rect
        x="1.17536"
        y="1.24933"
        width="123.052"
        height="37.4636"
        rx="3.30359"
        fill="#FFFDF9"
        stroke="#B5B2AA"
        strokeWidth="0.717419"
      />
      <rect
        x="1.17536"
        y="61.2904"
        width="123.052"
        height="37.4601"
        rx="3.30359"
        fill="#FFFDF9"
        stroke="#B5B2AA"
        strokeWidth="0.717419"
      />
      <circle cx="10.1813" cy="11.1249" r="3.82214" fill="#DBDBEC" />
      <rect
        x="16.1851"
        y="9.19531"
        width="31.7752"
        height="3.86"
        rx="1.93"
        fill="#D7D3C9"
      />
      <rect
        x="6.35913"
        y="19.123"
        width="112.069"
        height="3.86227"
        rx="1.93113"
        fill="#ECE9DF"
      />
      <rect
        x="6.35913"
        y="27.1602"
        width="87.9558"
        height="3.86227"
        rx="1.93113"
        fill="#ECE9DF"
      />
      <path
        d="M62.3939 90.2834C64.9797 90.2834 67.4595 89.2021 69.2879 87.2774C71.1163 85.3528 72.1436 82.7424 72.1436 80.0206C72.1436 77.2987 71.1163 74.6884 69.2879 72.7637C67.4595 70.8391 64.9797 69.7578 62.3939 69.7578C59.8082 69.7578 57.3283 70.8391 55.4999 72.7637C53.6715 74.6884 52.6443 77.2987 52.6443 80.0206C52.6443 82.7424 53.6715 85.3528 55.4999 87.2774C57.3283 89.2021 59.8082 90.2834 62.3939 90.2834V90.2834ZM67.142 78.9943L61.419 86.1783V81.0469H57.6459L63.3689 73.8629V78.9943H67.142Z"
        fill="#FF4F00"
      />
    </svg>
  );
};
